<template>
  <div :style='{width: panelWidth}' >
    <el-form ref="form" label-position="right" label-width="100px" :style="`height: ${bookSetHeight}px;`">
      <el-form-item auto :label="$t('Book Set 2')" prop="bookSet2" :style='{margin: 5, width: panelWidth}' >
        <el-input class='inputauto' type="text" v-model="bookSet2" :placeholder="$t('Book Set 2')" :readonly="true" />
      </el-form-item>
    </el-form>
    <el-table ref='risksplittable' :data='tableData' class='riskTable' :height="currentPanelHeight" style='width: 100%; margin-top: 0px;' fit
        :cell-class-name = "() => 'lu-click'"
        :row-class-name="tableRowClassName"
        @sort-change='sortChange'
      >
      <el-table-column prop='instrumentName' ref='col1' sortable='custom' :dataKeys="['instrumentName']" sortFieldFormat="String" />
      <el-table-column align='center' :label='$t("Mio 1")' prop='exp1' ref='col2' sortable='custom' :dataKeys="['exp1']" sortFieldFormat="Number">
        <template slot-scope="data">
          <div style='text-align: right' :class='cellClass(data.row.exp1)'>{{ data.row.exp1 | formatAmount(1) }}</div>
        </template>
      </el-table-column>
      <el-table-column align='center' :label='$t("Mio 2")' prop='exp2' ref='col3' sortable='custom' :dataKeys="['exp2']" sortFieldFormat="Number">
        <template slot-scope="data">
          <div style='text-align: right' :class='cellClass(data.row.exp2)'>{{ data.row.exp2 | formatAmount(1) }}</div>
        </template>
      </el-table-column>
      <el-table-column align='center' :label='$t("PnL 1")' prop='pnl1' ref='col4' sortable='custom' :dataKeys="['pnl1']" sortFieldFormat="Number">
        <template slot-scope="data">
          <div style='text-align: right' :class='cellClass(data.row.pnl1)'>{{ data.row.pnl1 | formatAmount(0) }}</div>
        </template>
      </el-table-column>
      <el-table-column align='center' :label='$t("PnL 2")' prop='pnl2' ref='col5' sortable='custom' :dataKeys="['pnl2']" sortFieldFormat="Number">
        <template slot-scope="data">
          <div style='text-align: right' :class='cellClass(data.row.pnl2)'>{{ data.row.pnl2 | formatAmount(0) }}</div>
        </template>
      </el-table-column>
      <el-table-column align='center' :label='$t("Total Mio")' prop='exposure' ref='col6' sortable='custom' :dataKeys="['exposure']" sortFieldFormat="Number">
        <template slot-scope="data">
          <div style='text-align: right' :class='cellClass(data.row.exposure)'>{{ data.row.exposure | formatAmount(1) }}</div>
        </template>
      </el-table-column>
      <el-table-column align='center' :label='$t("Total PnL")' prop='profitAndLoss' ref='col7' sortable='custom' :dataKeys="['profitAndLoss']" sortFieldFormat="Number">
        <template slot-scope="data">
          <div style='text-align: right' :class='cellClass(data.row.profitAndLoss)'>{{ data.row.profitAndLoss | formatAmount(0) }}</div>
        </template>
      </el-table-column>
      <el-table-column align='center' :label='$t("VWAP")' prop='vwap' ref='col8' sortable='custom' :dataKeys="['vwap']" sortFieldFormat="Number">
        <template slot-scope="data">
          <div style='text-align: right' :class='cellClass(data.row.vwap)'>{{ data.row.vwap | formatRate(6) }}</div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog class="centered" :modal="false" :visible.sync="showDialog" :title="$t('Risk Split Config')" width="500px">
      <el-form ref="formDialog" lu-flex label-width="100px">
        <el-form-item :label="$t('Book Set 2')" prop="setbookSet2" style="width: 400px;">
          <el-input class='inputauto' type="textarea" autosize v-model="setbookSet2" :placeholder="$t('Book Set 2')" />
        </el-form-item>
        <el-form-item>
          <el-button class="button" icon="el-icon-check"  @click.stop='saveBookSet2'>{{ $t('save') }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import utils from '@/utils/formatNumber'
import { timestamp } from '@/utils'
import monitoringMixin from './mixins'
import { mapState } from 'vuex'

export default {
  name: 'RiskSplit',
  props: [ 'data', 'panel' ],
  mixins: [ monitoringMixin ],
  filters: {
    formatAmount (value, bookPnLMode) {
      if (!value) {
        return utils.formatAmount(0, 2, 3, bookPnLMode)
      }
      return utils.formatAmount(value, 2, 3, bookPnLMode)
    },
    formatRate: function (value, prec, decsep = '.', thsep = ' ', emptyIfZero = true) {
      value = value || 0
      let idx = ('' + value).indexOf('.')
      if (idx !== -1) prec = value.length - idx - 1
      return utils.formatNumber(value, prec, decsep, thsep, emptyIfZero)
    }
  },
  data: function () {
    return {
      tableData: [],
      currentFilter: { },
      bookSet2: '',
      setbookSet2: '',
      showDialog: false,
      bookSetHeight: 40
    }
  },
  watch: {
    data: {
      handler (value) {
        this.updateData(value)
      },
      immediate: true
    }
  },
  computed: {
    ...mapState({ panelConfig: state => state.settingsMonitor.settingParams.panelConfig }),
    currentPanelHeight () {
      if (this.panelHeight - this.bookSetHeight) {
        return this.panelHeight - this.bookSetHeight
      }
      return this.panelHeight
    }
  },
  methods: {
    onSettings () {
      this.setbookSet2 = this.bookSet2
      this.showDialog = !this.showDialog
    },
    saveBookSet2 () {
      this.$nextTick().then(() => {
        let cond = {
          functionId: 'setBookSet2',
          books: this.setbookSet2
        }

        this.$tango.getFunctionData(cond).then(rep => {
          if (rep.resultCode === 0) {
            this.$message({
              message: 'Risk Split Config updated successfully',
              type: 'success'
            })
            this.showDialog = false
          }
          else {
            this.$message({
              message: 'Risk Split Config update failed',
              type: 'error'
            })
          }
        }).catch(err => {
          this.$message({
            type: 'error',
            message: err.message
          })
        })
      })
    },
    sortChange: function(data) {
      const { column, order } = data

      let currentCol = this.getColumn(column.id)

      let dataKeys = []
      let sortFieldFormat = ""
      if (currentCol && currentCol.hasOwnProperty('$attrs')) {
        dataKeys = currentCol.$attrs.dataKeys
        sortFieldFormat = currentCol.$attrs.sortFieldFormat
      }

      this.currentFilter = { dataKeys, sortFieldFormat, order }
      this.dataSort()
    },
    getColumn: function(columnId) {
      return this.getColumns().find(item => item.columnId === columnId)
    },
    getColumns: function() {
      let columns = []
      for (let ref of ["col1", "col2", "col3", "col4", "col5", "col6", "col7", "col8"]) {
        if (this.$refs[ref]!==null && this.$refs[ref]!==undefined) {
          if (Array.isArray(this.$refs[ref])) {
            columns = columns.concat(this.$refs[ref])
          } else {
            columns.push(this.$refs[ref])
          }
        }
      }
      return columns
    },
    dataSort: function() {
      let { dataKeys, sortFieldFormat, order } = this.currentFilter
      if (!(Boolean(dataKeys) && Boolean(order))) {
        // default
        dataKeys = ['exposure']
        sortFieldFormat = 'Number'
        order = 'descending'
        this.currentFilter = { dataKeys, sortFieldFormat, order }
      }
      this.tableData.sort(this.sortBy(dataKeys,sortFieldFormat,order))
    },
    sortBy: function(dataKeys,sortFieldFormat,order) {
      return function(a,b) {
        let value = 0

        const getPropValue = (data,dataKeys,sortFieldFormat) => {
          let currentData = data
          for (let key of dataKeys) {
            if (currentData!==null && currentData!==undefined && currentData.hasOwnProperty(key)) {
              currentData = currentData[key]
            }
          }
          if (typeof currentData === "object") {
            if (sortFieldFormat === 'String') {
              currentData = ''
            } else if (sortFieldFormat === 'Number') {
              currentData = 0
            } else {
              currentData = 0
            }
          }

          //format
          if (sortFieldFormat === 'String') {
            value = currentData.toUpperCase() 
          } else if (sortFieldFormat === 'Number') {
            if (!currentData) {
              currentData = 0
            }
            value = Math.abs(parseFloat(currentData))
          }
          return value
        }

        let valueA = getPropValue(a,dataKeys,sortFieldFormat)
        let valueB = getPropValue(b,dataKeys,sortFieldFormat)

        // //ref
        if (a.instrumentName==='Instrument') {
          return -1
        }
        if (b.instrumentName==='Instrument') {
          return 1
        }

        if (valueA>valueB) {
          // return 1
          return order==='ascending' ? 1 : -1
        }
        else if (valueA<valueB) {
          // return  -1
          return order==='ascending' ? -1 : 1
        }

        return 0
      }
    },
    updateData(value) {
      let data = this.parseData(value)
      this.tableData = data.tableData
      this.bookSet2 = data.bookSet2
      this.dataSort()
      this.updateLayout()
    },
    updateLayout() {
      if (this.$refs.risksplittable && this.$refs.risksplittable.doLayout) {
          this.$refs.risksplittable.doLayout()
      }
    },
    getExcelSheetName() {
      let tmp = this.panelConfig.find(item => item.id === this.panel.id)
      let exportExcelFilePrefix = tmp ? tmp.exportExcelFilePrefix : ""

      return exportExcelFilePrefix
    },
    parseData (value) {
      let tableData = []
      let bookSet2 = ''
      if (value && value.length) {
        const currentValue = value[0]
        if (currentValue) {
          bookSet2 = currentValue.books
          const instrumentList = currentValue.instrumentList
          if (instrumentList && instrumentList.length) {
            instrumentList.forEach(item => {
              let row = {
                instrumentName: item.instrumentName,
                label: item.label,
                exp1: '',
                exp2: '',
                pnl1: '',
                pnl2: '',
                exposure: '',
                profitAndLoss: '',
                vwap: ''
              }

              if (item) {
                // exp1
                if (item.hasOwnProperty('exp1')) {
                  row.exp1 = item['exp1']
                } else {
                  row.exp1= "0.00"
                }

                // exp2
                if (item.hasOwnProperty('exp2')) {
                  row.exp2 = item['exp2']
                } else {
                  row.exp2= "0.00"
                }

                // pnl1
                if (item.hasOwnProperty('pnl1')) {
                  row.pnl1 = item['pnl1']
                } else {
                  row.pnl1= "0.00"
                }

                // pnl2
                if (item.hasOwnProperty('pnl2')) {
                  row.pnl2 = item['pnl2']
                } else {
                  row.pnl2= "0.00"
                }

                // exposure
                if (item.hasOwnProperty('exposure')) {
                  row.exposure = item['exposure']
                } else {
                  row.exposure= "0.00"
                }

                // profitAndLoss
                if (item.hasOwnProperty('profitAndLoss')) {
                  row.profitAndLoss = item['profitAndLoss']
                } else {
                  row.profitAndLoss= "0.00"
                }

                // vwap
                if (item.hasOwnProperty('vwap')) {
                  row.vwap = item['vwap']
                } else {
                  row.vwap= "0.00"
                }
              }
              tableData.push(row)
            })
          }
        }
      }
      return {
        tableData: tableData,
        bookSet2: bookSet2
      }
    },
    cellClass (value) {
      return value < 0 ? 'negative' : 'positive'
    },
    handleDownload (dataList, sheetOnly) {
      return import('@/vendor/Export2Excel').then(excel => {
        let sheetList = []

        let data = this.parseData(dataList)
        
        let headers = [
          [ 'Book Set 2', data.bookSet2 ],
          [ '' ]
        ]

        // Cols
        headers[1].push(this.$t('Mio 1'))
        headers[1].push(this.$t('Mio 2'))
        headers[1].push(this.$t('PnL 1'))
        headers[1].push(this.$t('PnL 2'))
        headers[1].push(this.$t('Total Mio'))
        headers[1].push(this.$t('Total PnL'))
        headers[1].push(this.$t('VWAP'))

        let tableData = []
        data.tableData.forEach(row => {
          let thisRow = []
          thisRow.push(row.instrumentName)
          thisRow.push(row.exp1)
          thisRow.push(row.exp2)
          thisRow.push(row.pnl1)
          thisRow.push(row.pnl2)
          thisRow.push(row.exposure)
          thisRow.push(row.profitAndLoss)
          thisRow.push(row.vwap)

          tableData.push(thisRow)
        })

        sheetList.push({
          multiHeader: headers,
          data: tableData,
          merges: [ 'B1:H1' ],
          sheetName: this.getExcelSheetName()
        })

        if (sheetOnly) {
          // return sheetList
          return {
            isMultiTab: true,
            tabList: sheetList
          }
        } else {
          let filename = this.panel.exportExcelFilePrefix + '_' +  timestamp()

          excel.export_json_to_excel_lusis_multisheet({
            filename: filename,
            autoWidth: true,
            bookType: 'xlsx',
            sheets: sheetList
          })
        }
      })
    }
  }
}
</script>

<style lang='scss'>
.inputauto {
  .el-input, .el-input__inner {
    width: 100% !important;
    border: 0 !important;
  }
}

.centered {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>